import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import sortByStyles from './sort-by.module.scss'
import { FilterDropdown } from '@/components/search/FilterDropdown'
import { Radio } from '@/components/search/inputs/Radio'
import { constants } from '@/lib/constants'
import { storeSearchParameters } from '@/store/reducers/search'
import { selectSortBy } from '@/store/selectors/search'

type SortByProps = {
  toggleFilter: () => void
  isFilterOpen: boolean
}

export const SortBy = ({ toggleFilter, isFilterOpen = false }: SortByProps) => {
  const dispatch = useDispatch()
  const activeSortBy = useSelector(selectSortBy)
  const [selectedOption, setSelectedOption] = useState(activeSortBy)

  const onChangeSortBy = (sortId: string) => {
    dispatch(
      storeSearchParameters({
        filter: 'sortBy',
        value: Number(sortId),
      }),
    )
  }

  const getSortByPrettyName = (value: number) => {
    switch (value) {
      case 1:
        return 'Best value'
      case 2:
        return 'Price (low to high)'
      case 3:
        return 'Least value'
      case 4:
        return 'Price (high to low)'
      default:
        break
    }
  }

  return (
    <FilterDropdown
      title="Sort by"
      toggleFilter={toggleFilter}
      isFilterOpen={isFilterOpen}
      hasSelectedOptions={true}
      hasSpacingBottom={false}
      selectedOptions={[
        getSortByPrettyName(activeSortBy) || constants.searchSortingOptions.VALUE_HIGH_TO_LOW.label,
      ]}>
      <ul
        className={sortByStyles.options}
        tabIndex={-1}
        role="list">
        {Object.keys(constants.searchSortingOptions).map(item => {
          const value = constants.searchSortingOptions[item as keyof object].value

          return (
            <li
              tabIndex={0}
              key={item}>
              <Radio
                label={getSortByPrettyName(value)}
                value={value}
                isActive={selectedOption === value}
                onChange={() => {
                  setSelectedOption(value)
                  onChangeSortBy(value)
                }}
              />
            </li>
          )
        })}
      </ul>
    </FilterDropdown>
  )
}
